import { PalantirSizeEnum } from '@core/interfaces/palantir/sizes.interface';
import { PalantirTextTypeEnum } from './text.type';
var PalantirTextComponent = /** @class */ (function () {
    function PalantirTextComponent() {
        this.type = PalantirTextTypeEnum.text;
        this.size = PalantirSizeEnum.base;
        this.truncate = false;
        this.italic = false;
    }
    return PalantirTextComponent;
}());
export { PalantirTextComponent };
